import {Power3} from "gsap";
import React, {useState} from "react";

import useIsPlaying from "../common/player/useIsPlaying";
import YoutubePlayer from "../common/player/YoutubePlayer";
import {Player} from "../common/player/YoutubePlayerManager";
import FullWidthTransition from "./FullWidthTransition";
import PlayerCardThumbnail from "./PlayerCardThumbnail";

interface Props {
    elementId: string,
    videoId: string,
    title?: string,
    thumbnail: string,
    aspectRatio?: string,
    inline?: boolean,
}

const YoutubePlayerCard = ({elementId, videoId, title, thumbnail, aspectRatio, inline}: Props) => {
    const [player, setPlayer] = useState<Player>();
    const isPlaying = useIsPlaying(player);

    const onMouseClick = () => {
        if (player) {
            player.hideVideoInfo();
            player.playVideo();
        }
    };

    const onPause = () => {
        if (player) {
            player.pauseVideo();
        }
    };

    const Wrapper = inline ? 'div' : FullWidthTransition;

    return (
        <div>
            <Wrapper
                breakpoint={1024}
                duration={.6}
                ease={Power3.easeInOut}
                fullWidth={isPlaying}
                onPause={onPause}
                style={{aspectRatio: aspectRatio ?? `${16 / 9}`}}
            >
                <div className='position-relative w-full h-full'>
                    <YoutubePlayer
                        elementId={elementId}
                        onPlayerReady={setPlayer}
                        options={{
                            width: '100%',
                            height: '100%',
                            // TODO: Check if controls should be on or off
                            controls: false,
                            modestBranding: true,
                            playsInline: true,
                            videoId: videoId,
                        }}
                    />

                    <PlayerCardThumbnail className='position-absolute top-0 left-0 w-full h-full cursor-pointer'
                        isPlaying={isPlaying}
                        isReady={!!player}
                        onClick={onMouseClick}
                        src={thumbnail}
                    />
                </div>
            </Wrapper>

            {title && <h6 className='pt-2'>{title}</h6>}
        </div>
    );
};

export default YoutubePlayerCard;
